import React from "react";
import clsx from "clsx";
import { isEmpty } from "lodash";
import { BaseButton } from "src/components/ui/baseButton";
import { Text } from "src/components/ui/Text";

const Dialog = (props) => {
  const {
    title,
    onClickPrimary,
    onClose,
    open,
    content,
    onClickSecondary,
    primaryText,
    secondaryText,
    error,
    success,
  } = props;
  return (
    <div
      className={`modal p-4 bg-[rgba(0,0,0,0.5)] z-[9999] ${clsx({
        "modal-open": open,
      })}`}
    >
      <div className="modal-box flex flex-col gap-4">
        <Text
          variant="bold-18"
          className={`${clsx({
            "text-black": !error && !success,
            "text-vekin-message-error": error,
            "text-primary": success,
          })} text-center`}
        >
          {title}
        </Text>

        <Text
          data-theme="main"
          variant="medium-14"
          className="text-primary text-center bg-transparent"
        >
          {content}
        </Text>
        <div className="modal-action m-0">
          <div className="m-auto flex flex-row gap-4 mt-2">
            {error ? (
              <BaseButton
                variant="secondary"
                size="normal"
                onClick={onClickPrimary}
                className={`!min-w-[6.25rem] !bg-vekin-red100 hover:!bg-vekin-red100/80 !text-white `}
              >
                {primaryText}
              </BaseButton>
            ) : (
              <BaseButton
                variant="secondary"
                size="normal"
                onClick={onClickPrimary}
                className={`!min-w-[6.25rem] !bg-vekin hover:!bg-vekin-green80 !text-white`}
              >
                {primaryText}
              </BaseButton>
            )}

            {isEmpty(secondaryText) ? null : (
              <BaseButton
                variant="secondary"
                size="normal"
                onClick={onClickSecondary}
                className={`!min-w-[6.25rem] hover:!bg-black/80 !text-black hover:!text-white`}
              >
                {secondaryText}
              </BaseButton>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dialog;
